<input matInput type="text" [placeholder]="test">